import { memo, useCallback, useContext } from 'react'

import { TtsItemContext } from 'containers/SubSidebar/TtsContent/List/Item/contextApi'
import SpeakerVelocity from 'containers/SubSidebar/TtsContent/components/Velocity'
import { useGetTtsItemSpeed } from 'containers/SubSidebar/TtsContent/hooks'
import { dispatch } from 'store'
import { ttsThunks } from 'store/features/tts/thunks'

const TtsItemSpeakerVelocity: React.FC = () => {
  const { scrollableParentRef, id } = useContext(TtsItemContext)
  const speed = useGetTtsItemSpeed(id)

  const onClick = useCallback(
    (value: number) => {
      if (value !== speed) {
        dispatch(ttsThunks.setTtsItemSpeed(id, value))
      }
    },
    [speed, id]
  )

  return (
    <SpeakerVelocity
      initialValue={speed}
      onClick={onClick}
      scrollableParentRef={scrollableParentRef}
    />
  )
}

export default memo(TtsItemSpeakerVelocity)
